import type { PipeTransform } from '@angular/core'
import { Pipe } from '@angular/core'

@Pipe({ name: 'formatAuthorName' })
export class FormatAuthorNamePipe implements PipeTransform {
  transform(author: FormatAuthorNameFields | null): string {
    if (!author) {
      return ''
    }

    const pretitle = author.pre_title ? `${author.pre_title} ` : ''
    const initials = author.initials ?? ''
    const firstName = author.first_name ? ` (${author.first_name})` : ''

    // Handle Dutch middle names (like "van", "den", "der")
    let lastName = ''
    if (author.last_name) {
      if (author.middle_name) {
        // For Dutch names, place the middle name before the last name
        lastName = ` ${author.middle_name} ${author.last_name}`
      } else {
        lastName = ` ${author.last_name}`
      }
    }

    const postTitle = author.post_title ? `, ${author.post_title}` : ''

    // If we have the component parts, construct the full name
    if (
      author.last_name ||
      author.first_name ||
      author.initials ||
      author.pre_title
    ) {
      return pretitle + initials + firstName + lastName + postTitle
    }

    // Fallback to pdf_author_name or name if the component parts aren't available
    return author.pdf_author_name ?? author.name ?? ''
  }
}

export interface FormatAuthorNameFields {
  first_name?: string
  last_name?: string
  middle_name?: string
  pre_title?: string
  initials?: string
  post_title?: string
  pdf_author_name?: string
  name?: string
}
